export const SET_PRODUCTION_COMPANY = 'SET_PRODUCTION_COMPANY';

export const CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_FAIL = 'CREATE_JOB_FAIL';
export const CREATE_JOB_RESET = 'CREATE_JOB_RESET';

export const DELETE_JOB_REQUEST = 'DELETE_JOB_REQUEST';
export const DELETE_JOB_SUCCESS = 'DELETE_JOB_SUCCESS';
export const DELETE_JOB_FAIL = 'DELETE_JOB_FAIL';

export const DELETE_JOBS_BULK_REQUEST = 'DELETE_JOBS_BULK_REQUEST';
export const DELETE_JOBS_BULK_SUCCESS = 'DELETE_JOBS_BULK_SUCCESS';
export const DELETE_JOBS_BULK_FAIL = 'DELETE_JOBS_BULK_FAIL';

export const FETCH_COMPANY_JOBS_REQUEST = 'FETCH_COMPANY_JOBS_REQUEST';
export const FETCH_COMPANY_JOBS_SUCCESS = 'FETCH_COMPANY_JOBS_SUCCESS';
export const FETCH_COMPANY_JOBS_FAIL = 'FETCH_COMPANY_JOBS_FAIL';

export const FETCH_ARCHIVED_COMPANY_JOBS_REQUEST =
  'FETCH_ARCHIVED_COMPANY_JOBS_REQUEST';

export const FETCH_JOB_ROLE_GROUPS_REQUEST = 'FETCH_JOB_ROLE_GROUPS_REQUEST';
export const FETCH_JOB_ROLE_GROUPS_SUCCESS = 'FETCH_JOB_ROLE_GROUPS_SUCCESS';
export const FETCH_JOB_ROLE_GROUPS_FAIL = 'FETCH_JOB_ROLE_GROUPS_FAIL';

export const CREATE_JOB_ROLE_GROUP_REQUEST = 'CREATE_JOB_ROLE_GROUP_REQUEST';
export const CREATE_JOB_ROLE_GROUP_SUCCESS = 'CREATE_JOB_ROLE_GROUP_SUCCESS';
export const CREATE_JOB_ROLE_GROUP_FAIL = 'CREATE_JOB_ROLE_GROUP_FAIL';

export const UPDATE_JOB_ROLE_GROUP_REQUEST = 'UPDATE_JOB_ROLE_GROUP_REQUEST';
export const UPDATE_JOB_ROLE_GROUP_SUCCESS = 'UPDATE_JOB_ROLE_GROUP_SUCCESS';
export const UPDATE_JOB_ROLE_GROUP_FAIL = 'UPDATE_JOB_ROLE_GROUP_FAIL';

export const UPDATE_JOB_ROLE_GROUP_TYPE_REQUEST =
  'UPDATE_JOB_ROLE_GROUP_TYPE_REQUEST';
export const UPDATE_JOB_ROLE_GROUP_TYPE_SUCCESS =
  'UPDATE_JOB_ROLE_GROUP_TYPE_SUCCESS';
export const UPDATE_JOB_ROLE_GROUP_TYPE_FAIL =
  'UPDATE_JOB_ROLE_GROUP_TYPE_FAIL';

export const UPDATE_JOB_ROLE_GROUP_ORDER_REQUEST =
  'UPDATE_JOB_ROLE_GROUP_ORDER_REQUEST';
export const UPDATE_JOB_ROLE_GROUP_ORDER_SUCCESS =
  'UPDATE_JOB_ROLE_GROUP_ORDER_SUCCESS';
export const UPDATE_JOB_ROLE_GROUP_ORDER_FAIL =
  'UPDATE_JOB_ROLE_GROUP_ORDER_FAIL';

export const FETCH_JOB_ROLES_REQUEST = 'FETCH_JOB_ROLES_REQUEST';
export const FETCH_JOB_ROLES_SUCCESS = 'FETCH_JOB_ROLES_SUCCESS';
export const FETCH_JOB_ROLES_FAIL = 'FETCH_JOB_ROLES_FAIL';

export const CREATE_JOB_ROLE_REQUEST = 'CRATE_JOB_ROLE_REQUEST';
export const CREATE_JOB_ROLE_SUCCESS = 'CRATE_JOB_ROLE_SUCCESS';
export const CREATE_JOB_ROLE_FAIL = 'CREATE_JOB_ROLE_FAIL';

export const UPDATE_JOB_ROLE_TYPE_REQUEST = 'UPDATE_JOB_ROLE_TYPE_REQUEST';
export const UPDATE_JOB_ROLE_TYPE_SUCCESS = 'UPDATE_JOB_ROLE_TYPE_SUCCESS';
export const UPDATE_JOB_ROLE_TYPE_FAIL = 'UPDATE_JOB_ROLE_TYPE_FAIL';

export const DELETE_JOB_ROLE_REQUEST = 'DELETE_JOB_ROLE_REQUEST';
export const DELETE_JOB_ROLE_SUCCESS = 'DELETE_JOB_ROLE_SUCCESS';
export const DELETE_JOB_ROLE_FAIL = 'DELETE_JOB_ROLE_FAIL';

export const FETCH_JOB_DETAILS_REQUEST = 'FETCH_JOB_DETAILS_REQUEST';
export const FETCH_JOB_DETAILS_SUCCESS = 'FETCH_JOB_DETAILS_SUCCESS';

export const FETCH_JOB_DETAILS_FAIL = 'FETCH_JOB_DETAILS_FAIL';

export const FETCH_JOB_MEMOS_REQUEST = 'FETCH_JOB_MEMOS_REQUEST';
export const FETCH_JOB_MEMOS_SUCCESS = 'FETCH_JOB_MEMOS_SUCCESS';
export const FETCH_JOB_MEMOS_FAIL = 'FETCH_JOB_MEMOS_FAIL';

export const SET_JOB = 'SET_JOB';

export const GET_CONTRACTORS_WITH_MEMO_REQUEST =
  'GET_CONTRACTORS_WITH_MEMO_REQUEST_REQUEST';
export const GET_CONTRACTORS_WITH_MEMO_SUCCESS =
  'GET_CONTRACTORS_WITH_MEMO_SUCCESS';
export const GET_CONTRACTORS_WITH_MEMO_FAIL = 'GET_CONTRACTORS_WITH_MEMO_FAIL';

export const GET_CONTRACTORS_WITHOUT_MEMO_REQUEST =
  'GET_CONTRACTORS_WITHOUT_MEMO_REQUEST';
export const GET_CONTRACTORS_WITHOUT_MEMO_SUCCESS =
  'GET_CONTRACTORS_WITHOUT_MEMO_SUCCESS';
export const GET_CONTRACTORS_WITHOUT_MEMO_FAIL =
  'GET_CONTRACTORS_WITHOUT_MEMO_FAIL';

export const SET_CONTRACTOR = 'SET_CONTRACTOR';

export const CREATE_JOB_MEMO_REQUEST = 'CREATE_JOB_MEMO_REQUEST';
export const CREATE_JOB_MEMO_SUCCESS = 'CREATE_JOB_MEMO_SUCCESS';
export const CREATE_JOB_MEMO_FAIL = 'CREATE_JOB_MEMO_FAIL';

export const DELETE_JOB_MEMO_REQUEST = 'DELETE_JOB_MEMO_REQUEST';
export const DELETE_JOB_MEMO_SUCCESS = 'DELETE_JOB_MEMO_SUCCESS';
export const DELETE_JOB_MEMO_FAIL = 'DELETE_JOB_MEMO_FAIL';

export const CANCEL_JOB_MEMO_REQUEST = 'CANCEL_JOB_MEMO_REQUEST';
export const CANCEL_JOB_MEMO_SUCCESS = 'CANCEL_JOB_MEMO_SUCCESS';
export const CANCEL_JOB_MEMO_FAIL = 'CANCEL_JOB_MEMO_FAIL';

export const UPDATE_JOB_MEMO_REQUEST = 'UPDATE_JOB_MEMO_REQUEST';
export const UPDATE_JOB_MEMO_SUCCESS = 'UPDATE_JOB_MEMO_SUCCESS';
export const UPDATE_JOB_MEMO_FAIL = 'UPDATE_JOB_MEMO_FAIL';

export const SWAP_JOB_MEMO_REQUEST = 'SWAP_JOB_MEMO_REQUEST';
export const SWAP_JOB_MEMO_SUCCESS = 'SWAP_JOB_MEMO_SUCCESS';
export const SWAP_JOB_MEMO_FAIL = 'SWAP_JOB_MEMO_FAIL';

export const UPDATE_JOB_DETAILS_REQUEST = 'UPDATE_JOB_DETAILS_REQUEST';
export const UPDATE_JOB_DETAILS_SUCCESS = 'UPDATE_JOB_DETAILS_SUCCESS';
export const UPDATE_JOB_DETAILS_FAIL = 'UPDATE_JOB_DETAILS_FAIL';
export const UPDATE_JOB_RESET_REQUEST = 'UPDATE_JOB_RESET_REQUEST';

export const FETCH_JOB_FULLVIEW_REQUEST = 'FETCH_JOB_FULLVIEW_REQUEST';
export const FETCH_JOB_FULLVIEW_SUCCESS = 'FETCH_JOB_FULLVIEW_SUCCESS';
export const FETCH_JOB_FULLVIEW_FAIL = 'FETCH_JOB_FULLVIEW_FAIL';

export const BOOK_CREW_REQUEST = 'BOOK_CREW_REQUEST';
export const BOOK_CREW_SUCCESS = 'BOOK_CREW_SUCCESS';
export const BOOK_CREW_FAIL = 'BOOK_CREW_FAIL';

export const SHOW_DEAL_MEMO = 'SHOW_DEAL_MEMO';
export const CLOSE_DEAL_MEMO = 'CLOSE_DEAL_MEMO';

export const SHOW_HOLD_MEMO = 'SHOW_HOLD_MEMO';
export const CLOSE_HOLD_MEMO = 'CLOSE_HOLD_MEMO';

export const SHOW_ARCHIVED_MEMO = 'SHOW_ARCHIVED_MEMO';
export const CLOSE_ARCHIVED_MEMO = 'CLOSE_ARCHIVED_MEMO';

export const CREATE_VIRTUAL_MEMO_REQUEST = 'CREATE_VIRTUAL_MEMO_REQUEST';
export const CREATE_VIRTUAL_MEMO_SUCCESS = 'CREATE_VIRTUAL_MEMO_SUCCESS';
export const CREATE_VIRTUAL_MEMO_FAIL = 'CREATE_VIRTUAL_MEMO_FAIL';

export const UPDATE_VIRTUAL_MEMO_REQUEST = 'UPDATE_VIRTUAL_MEMO_REQUEST';
export const UPDATE_VIRTUAL_MEMO_SUCCESS = 'UPDATE_VIRTUAL_MEMO_SUCCESS';
export const UPDATE_VIRTUAL_MEMO_FAIL = 'UPDATE_VIRTUAL_MEMO_FAIL';

export const DELETE_VIRTUAL_MEMO_REQUEST = 'DELETE_VIRTUAL_MEMO_REQUEST';
export const DELETE_VIRTUAL_MEMO_SUCCESS = 'DELETE_VIRTUAL_MEMO_SUCCESS';
export const DELETE_VIRTUAL_MEMO_FAIL = 'DELETE_VIRTUAL_MEMO_FAIL';

export const SET_VISIBLE_CREW_CONFIRM = 'SET_VISIBLE_CREW_CONFIRM';
export const SET_CREW_OPEN_DEPARTMENTS = 'SET_CREW_OPEN_DEPARTMENTS';
export const SET_CREW_ACTIVE_POSITION = 'SET_CREW_ACTIVE_POSITION';

export const FETCH_CREW_TEMPLATE_LIST_REQUEST =
  'FETCH_CREW_TEMPLATE_LIST_REQUEST';
export const FETCH_CREW_TEMPLATE_LIST_SUCCESS =
  'FETCH_CREW_TEMPLATE_LIST_SUCCESS';
export const FETCH_CREW_TEMPLATE_LIST_FAIL = 'FETCH_CREW_TEMPLATE_LIST_FAIL';

export const CREATE_CREW_TEMPLATE_REQUEST = 'CREATE_CREW_TEMPLATE_REQUEST';
export const CREATE_CREW_TEMPLATE_SUCCESS = 'CREATE_CREW_TEMPLATE_SUCCESS';
export const CREATE_CREW_TEMPLATE_FAIL = 'CREATE_CREW_TEMPLATE_FAIL';

export const LOAD_CREW_TEMPLATE_REQUEST = 'LOAD_CREW_TEMPLATE_REQUEST';
export const LOAD_CREW_TEMPLATE_SUCCESS = 'LOAD_CREW_TEMPLATE_SUCCESS';
export const LOAD_CREW_TEMPLATE_FAIL = 'LOAD_CREW_TEMPLATE_FAIL';

export const DELETE_CREW_TEMPLATE_REQUEST = 'DELETE_CREW_TEMPLATE_REQUEST';
export const DELETE_CREW_TEMPLATE_SUCCESS = 'DELETE_CREW_TEMPLATE_SUCCESS';
export const DELETE_CREW_TEMPLATE_FAIL = 'DELETE_CREW_TEMPLATE_FAIL';

export const ARCHIVE_JOB_REQUEST = 'ARCHIVE_JOB_REQUEST';
export const ARCHIVE_JOB_SUCCESS = 'ARCHIVE_JOB_SUCCESS';
export const ARCHIVE_JOB_FAIL = 'ARCHIVE_JOB_FAIL';

export const DELETE_CONTRACTOR_ATTACHMENT_REQUEST =
  'DELETE_CONTRACTOR_ATTACHMENT_REQUEST';
export const DELETE_CONTRACTOR_ATTACHMENT_SUCCESS =
  'DELETE_CONTRACTOR_ATTACHMENT_SUCCESS';
export const DELETE_CONTRACTOR_ATTACHMENT_FAIL =
  'DELETE_CONTRACTOR_ATTACHMENT_FAIL';

export const REINSTATE_JOB_DETAILS_REQUEST = 'REINSTATE_JOB_DETAILS_REQUEST';
export const REINSTATE_JOB_DETAILS_SUCCESS = 'REINSTATE_JOB_DETAILS_SUCCESS';
export const REINSTATE_JOB_DETAILS_FAIL = 'REINSTATE_JOB_DETAILS_FAIL';

export const DELETE_BOOK_MEMO_REQUEST = 'DELETE_BOOK_MEMO_REQUEST';
export const DELETE_BOOK_MEMO_SUCCESS = 'DELETE_BOOK_MEMO_SUCCESS';
export const DELETE_BOOK_MEMO_FAIL = 'DELETE_BOOK_MEMO_FAIL';

export const FETCH_ARCHIVE_JOB_MEMOS_REQUEST =
  'FETCH_ARCHIVE_JOB_MEMOS_REQUEST';
export const FETCH_ARCHIVE_JOB_MEMOS_SUCCESS =
  'FETCH_ARCHIVE_JOB_MEMOS_SUCCESS';
export const FETCH_ARCHIVE_JOB_MEMOS_FAIL = 'FETCH_ARCHIVE_JOB_MEMOS_FAIL';
export const CURRENT_JOB_VIEW_DISPLAY = 'CURRENT_JOB_VIEW_DISPLAY';
export const CURRENT_JOB_VIEW_DISPLAY_SUCCESS =
  'CURRENT_JOB_VIEW_DISPLAY_SUCCESS';

export const UPDATE_JOB_DETAILS_ON_DRAGEND = 'UPDATE_JOB_DETAILS_ON_DRAGEND';

export const ADD_COMMENT_REQUEST = 'ADD_COMMENT_REQUEST';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAIL = 'ADD_COMMENT_FAIL';

export const VIEWED_COMMENT_REQUEST = 'VIEWED_COMMENT_REQUEST';
export const VIEWED_COMMENT_SUCCESS = 'VIEWED_COMMENT_SUCCESS';
export const VIEWED_COMMENT_FAIL = 'VIEWED_COMMENT_FAIL';

export const UPDATE_VIEWED_COMMENT_COUNTER = 'UPDATE_VIEWED_COMMENT_COUNTER';

export const FETCH_ADDITIONAL_JOB_PAYMENT_REQUEST =
  'FETCH_ADDITIONAL_JOB_PAYMENT_REQUEST';
export const FETCH_ADDITIONAL_JOB_PAYMENT_SUCCESS =
  'FETCH_ADDITIONAL_JOB_PAYMENT_SUCCESS';
export const FETCH_ADDITIONAL_JOB_PAYMENT_FAIL =
  'FETCH_ADDITIONAL_JOB_PAYMENT_FAIL';

export const FETCH_JOB_PENDING_MEMOS_REQUEST =
  'FETCH_JOB_PENDING_MEMOS_REQUEST';
export const FETCH_JOB_PENDING_MEMOS_SUCCESS =
  'FETCH_JOB_PENDING_MEMOS_SUCCESS';
export const FETCH_JOB_PENDING_MEMOS_FAIL = 'FETCH_JOB_PENDING_MEMOS_FAIL';
